// extracted by mini-css-extract-plugin
module.exports = {"reset_btn":"ChangePassword_reset_btn__5BtEa","password_note":"ChangePassword_password_note___Nuu7"};